var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-popover",
        {
          attrs: { placement: "top", width: "350", trigger: "manual" },
          model: {
            value: _vm.visible,
            callback: function ($$v) {
              _vm.visible = $$v
            },
            expression: "visible",
          },
        },
        [
          _c(
            "span",
            { staticStyle: { color: "#F67C7C" } },
            [
              _c("svg-icon", {
                staticStyle: { "margin-right": "5px" },
                attrs: { "icon-class": "tip-fill" },
              }),
              _vm._v(_vm._s(_vm.$t("tips.add_up_six_account"))),
            ],
            1
          ),
          _c(
            "el-button",
            {
              staticClass: "add-btn",
              attrs: {
                slot: "reference",
                type: "primary",
                icon: "el-icon-plus",
                disabled: _vm.bankAccountList.length >= 6,
              },
              on: { click: _vm.onClickAddBtn },
              slot: "reference",
            },
            [_vm._v(_vm._s(_vm.$t("data.add_new_bank_account")))]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "bank-box" },
        _vm._l(_vm.bankAccountList, function (item, index) {
          var _obj
          return _c("div", { key: index, staticClass: "bank-item" }, [
            _c(
              "div",
              {
                staticClass: "bank-head",
                class:
                  ((_obj = {}),
                  (_obj[_vm.aduitStatus[item.audit_status]] = true),
                  _obj),
              },
              [
                _c("span", [
                  _vm._v(
                    " " +
                      _vm._s(
                        item.audit_status === 1
                          ? _vm.$t("system.reviewing")
                          : item.audit_status === 2
                          ? _vm.$t("system.activated")
                          : _vm.$t("system.reject")
                      ) +
                      " "
                  ),
                ]),
              ]
            ),
            _c(
              "div",
              { staticClass: "content" },
              [
                _c(
                  "div",
                  {
                    staticClass: "content-item ",
                    staticStyle: { "margin-bottom": "10px" },
                  },
                  [
                    _c("span", { staticClass: "name" }, [
                      _vm._v(_vm._s(_vm.$t("data.currency")) + ":"),
                    ]),
                    _c(
                      "span",
                      { staticClass: "value" },
                      [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type:
                                item.settlement_type ===
                                _vm.SETTLEMENT_TYPE["usd"]
                                  ? "success"
                                  : "primary",
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.showCurrency(item)))]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
                _c("div", { staticClass: "content-item mb-16" }, [
                  _c("span", { staticClass: "name" }, [
                    _vm._v(_vm._s(_vm.$t("merchant.account_bank")) + ":"),
                  ]),
                  _c("span", { staticClass: "value" }, [
                    _vm._v(_vm._s(item.settlement_bank)),
                  ]),
                ]),
                _c("div", { staticClass: "content-item mb-16" }, [
                  _c("span", { staticClass: "name" }, [
                    _vm._v(_vm._s(_vm.$t("merchant.account_name")) + ":"),
                  ]),
                  _c("span", { staticClass: "value" }, [
                    _vm._v(_vm._s(item.settlement_bank_account_name)),
                  ]),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "content-item",
                    staticStyle: { "padding-right": "80px" },
                  },
                  [
                    _c("span", { staticClass: "name" }, [
                      _vm._v(_vm._s(_vm.$t("merchant.account_num")) + ":"),
                    ]),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(item.settlement_bank_account_num)),
                    ]),
                  ]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "btn-bank-delete",
                    staticStyle: {
                      "padding-left": "10px",
                      "padding-right": "10px",
                    },
                    attrs: { size: "mini", type: "danger", plain: "" },
                    on: {
                      click: function ($event) {
                        return _vm.clickDelete(item)
                      },
                    },
                  },
                  [
                    _c("svg-icon", { attrs: { "icon-class": "delete" } }),
                    _vm._v(" " + _vm._s(_vm.$t("components.delete")) + " "),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        }),
        0
      ),
      _c("AddBankAccountModal", {
        ref: "addBankAccountModal",
        on: { submit: _vm.getBankAccountList },
      }),
      _c("DeleteBankAccountModal", {
        ref: "deleteBankAccountModal",
        on: { submit: _vm.getBankAccountList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }